import type { FaireProductEntity } from "../../entity_types/product";

export const p_tk7j2gmx9n: FaireProductEntity = {
  token: "p_tk7j2gmx9n",
  type: "product",
  name: "Clean Paws No-Rinse Foaming Cleanser",
  brandToken: "b_bf7zwxbsts",
  brandName: "Dandylion",
  imageUrl: "https://cdn.faire.com/fastly/d0725b57b2b65a67e6d8ae62e12955d059a64bb66b35006fc440ab65d9e59aa1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/382e78dc5492ef245ba43e67e82f26c128faf31f3226e9be3cb83e29ace1ab6f.png",
    "https://cdn.faire.com/fastly/5a96c741597417937813ea7724505b59bdb7e5aba3831b2175f2be4402267c89.png",
    "https://cdn.faire.com/fastly/295a2bff3a5530d60b6a150d1011cbb495b0e622eff1a00c0eb998604cae5f34.png",
    "https://cdn.faire.com/fastly/b3a09d606e6c7f8796d5dd03c0819feaf0db54ea7494a12af5cdcc929ff344b0.png",
    "https://cdn.faire.com/fastly/c1d696133468c6db3c7574c3ba436af05febc9b1e9fd8ff79e5b1b5a0a44f4cc.png",
    "https://cdn.faire.com/fastly/7ffdbbdddbda41f2aaff560e020820a91841883f9914e1eb61ac503561649cd7.png",
    "https://cdn.faire.com/fastly/a15d4b57016d6fed4c67522c86eec7744d0ae79affb32befc2bda3e39270fd62.png",
    "https://cdn.faire.com/fastly/7b9c75c8aa1b4fad1497141291b99b82501fa652e0f58093833ed5eea51d819e.png",
    "https://cdn.faire.com/fastly/39f170ebda60e8a55c7f14d52719aa0178c6de027c9137d1dbfcfedc13d130c2.png",
    "https://cdn.faire.com/fastly/ad36f70fe7d1a2acc30813d28343e41425343b3229748fb0f8a89ebe27f421e1.png",
    "https://cdn.faire.com/fastly/15e297b2efd0d126261f8bd9ef79a26a7b3ee043afaeb29ec04c20dfcdb65003.png"
  ],
  priceDollars: 9,
  description: "The post-walk essential you've been looking for.\n\nWhy we love it: The easiest way to clean your dog's paws after every walk.\n\nVet-Dermatologist Approved | Fragrance-Free | pH-Balanced for Dogs | Lick-Safe | Vegan | Cruelty-Free\n\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T16:24:37.900Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
